<template>
  <component
    :is="levelComponent.componentType"
    @setWindowMode="$emit('setWindowMode', $event)"
    @quit="quit"
  />
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        currentLevel: 'currentLevel',
        levelComponent: 'levelComponent',
      })
    },
    emits: [
      'quit',
      'toggle',
      'setWindowMode'
    ],
    mounted() {
      this.trackEvent('open', 'toggle-advisor', true)
    },
    methods: {
      quit() {
        this.trackEvent('close', 'toggle-advisor', false)
        this.$emit('toggle')
      }
    }
  }
</script>